import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";

// Global dayjs plugin setup — imported once from src/index.tsx (and
// setupTests.ts for the test environment). Files can then `import dayjs
// from "dayjs"` and use .tz()/.utc()/localized format tokens directly.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

export default dayjs;
